import React from "react";

const LockedIcon = () => (
  <svg width="10" height="10" viewBox="0 0 10 10" fill="none" xmlns="http://www.w3.org/2000/svg">
    <g clipPath="url(#clip0_1113_7431)">
      <path
        d="M7.91667 4.58398H2.08333C1.6231 4.58398 1.25 4.95708 1.25 5.41732V8.75065C1.25 9.21089 1.6231 9.58398 2.08333 9.58398H7.91667C8.3769 9.58398 8.75 9.21089 8.75 8.75065V5.41732C8.75 4.95708 8.3769 4.58398 7.91667 4.58398Z"
        stroke="white"
        strokeMiterlimit="10"
        strokeLinecap="square"
      />
      <path
        d="M5.00033 7.91667C5.46056 7.91667 5.83366 7.54357 5.83366 7.08333C5.83366 6.6231 5.46056 6.25 5.00033 6.25C4.54009 6.25 4.16699 6.6231 4.16699 7.08333C4.16699 7.54357 4.54009 7.91667 5.00033 7.91667Z"
        stroke="white"
        strokeMiterlimit="10"
        strokeLinecap="square"
      />
      <path
        d="M7.08366 2.91612V2.49945C7.0891 1.95247 6.87708 1.42571 6.49421 1.03503C6.11134 0.644349 5.58898 0.421726 5.04199 0.416118H5.00033C4.45334 0.410675 3.92659 0.622702 3.53591 1.00557C3.14522 1.38844 2.9226 1.9108 2.91699 2.45778V2.91612"
        stroke="white"
        strokeMiterlimit="10"
        strokeLinecap="square"
      />
    </g>
    <defs>
      <clipPath id="clip0_1113_7431">
        <rect width="10" height="10" fill="white" />
      </clipPath>
    </defs>
  </svg>
);

export default LockedIcon;
